import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useSelector } from "react-redux";
import { OfferStatusCssClasses } from "../OffersUIHelpers";
import { useOffersUIContext } from "../OffersUIContext";

const selectedOffers = (entities, ids) => {
  const _offers = [];
  ids.forEach((id) => {
    const offer = entities.find((el) => el.id === id);
    if (offer) {
      _offers.push(offer);
    }
  });
  return _offers;
};

export function OffersFetchDialog({ show, onHide }) {
  // Offers UI Context
  const offersUIContext = useOffersUIContext();
  const offersUIProps = useMemo(() => {
    return {
      ids: offersUIContext.ids,
    };
  }, [offersUIContext]);

  // Offers Redux state
  const { offers } = useSelector(
    (state) => ({
      offers: selectedOffers(
        state.offers.entities,
        offersUIProps.ids
      ),
    }),
    shallowEqual
  );

  // if offers weren't selected we should close modal
  useEffect(() => {
    if (!offersUIProps.ids || offersUIProps.ids.length === 0) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offersUIProps.ids]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          Fetch selected elements
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="timeline timeline-5 mt-3">
          {offers.map((offer) => (
            <div className="timeline-item align-items-start" key={`id${offer.id}`}>
              <div className="timeline-label font-weight-bolder text-dark-75 font-size-lg text-right pr-3" />
              <div className="timeline-badge">
                <i
                  className={`fa fa-genderless text-${
                    OfferStatusCssClasses[offer.status]
                  } icon-xxl`}
                />
              </div>
              <div className="timeline-content text-dark-50 mr-5">
                <span
                    className={`label label-lg label-light-${
                      OfferStatusCssClasses[offer.status]
                    } label-inline`}
                  >
                    ID: {offer.id}
                </span>
                <span className="ml-3">{offer.lastName}, {offer.firstName}</span>                
              </div>
            </div>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-primary btn-elevate"
          >
            Ok
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
